<script setup>
import { l } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();

const items = computed(() => {
	const items = [{
		value: 0,
		text: l('showresult.filter.paymentMethodIncluded.chooseMethod')
	}];

	resultQueryStore.state.response.uniquePaymentMethods.forEach((value) => {
		const method = js_params.module.Filters.paymentMethodsAll[value];
		if (!method) {
			return;
		}
		items.push({
			value: value,
			text: method
		});
	});

	return items;
});

const selected = ref(0);

watch(() => selected.value, (value) => {
	const filtersValue = value === 0 ? null : value;
	filtersStore.set({ key: 'paymentMethodIncluded', value: filtersValue });
});

// Watch paymentMethodIncluded from filtersStore
watch(() => filtersStore.state.paymentMethodIncluded, (value) => {
	if (value === null) {
		selected.value = 0;
	}
});

</script>

<template>
  <FiltersItemContent>
    <template #title>
      {{ $l('showresult.filter.paymentMethodIncluded') }}
    </template>
    <template #content>
      <BaseSelect
        v-model:selected="selected"
        :items="items"
        :aria-label="$l('showresult.filter.paymentMethodIncluded')"
        style="margin-bottom: 1rem;"
      />
    </template>
  </FiltersItemContent>
</template>
